import { useTranslate } from "helpers";
import { ContactInfoHeaderProps } from "./types";

const ContactInfoHeader = ({
    contactDetail,
    onAdd,
}: ContactInfoHeaderProps) => {
    const { t } = useTranslate();

    if (!contactDetail.id) return <></>;

    return (
        <>
         
        </>
    );
};

export default ContactInfoHeader;
